import { getRegistryURL } from "./Registry";
import { buildGetOptions, buildPostOptions, fetchWithErrorHandling } from "../FetchUtils";
import { useAuthUser } from "react-auth-kit";

export interface IRegistryFilesMetadata {
  registryFileVersion: number;
  registryFileUpdateTime: number;
  compiledDataSchemaVersion: number;
  compiledDataSchemaUpdateTime: number;
  tfidTypesFileVersion: number;
  tfidTypesFileUpdateTime: number;
}

export const getFilesMetadata = async (accessToken: string, baseURL: string): Promise<IRegistryFilesMetadata> => {
  if (baseURL.endsWith("/")) {
    baseURL = baseURL.slice(0, -1);
  }
  return fetchWithErrorHandling(baseURL + "/v1/registry/files-metadata", buildGetOptions(accessToken));
};

export const syncFiles = async (accessToken: string, baseURL: string) => {
  if (baseURL.endsWith("/")) {
    baseURL = baseURL.slice(0, -1);
  }
  return fetchWithErrorHandling(getRegistryURL() + "/v1/registry/sync-files", buildPostOptions(accessToken, { baseURL }));
};

export const cloneDataEntities = async (
  accessToken: string,
  entityIds: string[],
  sourceBaseURL: string,
  targetBaseURL: string,
  recursive?: boolean,
) => {
  return fetchWithErrorHandling(
    getRegistryURL() + "/v1/registry/clone-data-entities",
    buildPostOptions(accessToken, { entityIds, sourceBaseURL, targetBaseURL, recursive }),
  );
};

export const useRegistryService = () => {
  const authUser = useAuthUser();
  const accessToken = authUser()?.access_token;

  return {
    getFilesMetadata: (baseURL: string) => getFilesMetadata(accessToken, baseURL),
    syncFiles: (baseURL: string) => syncFiles(accessToken, baseURL),
    cloneDataEntities: (entityIds: string[], sourceBaseURL: string, targetBaseURL: string, recursive?: boolean) =>
      cloneDataEntities(accessToken, entityIds, sourceBaseURL, targetBaseURL, recursive),
  };
};
